export default "__VITE_ASSET__3bwtz75o__"